import { langType } from './../types'

const lang: langType = {
  skills: 'Skills',
  interest: 'Hobby',
  team: 'Team',
  nickname: 'Nick name',
  giveAName: 'Give a name',
  signature: 'Signature',
  baseInfo: 'Base info',
  id: 'Employee id',
  brithday: 'Brithday',
  updateBaseInfo: 'Update base info',
  add: 'Add',
  selectSkillAndInterst: 'Please select your skills and hobby',
  saveAndClose: 'Save and close',
  adminTips: 'Please input skills and hobby,use ; to division',
  skillAdmin: 'Skill tags admin',
  needSkills: 'Skills required!'
}

export default lang
